import { useQuery } from "@tanstack/react-query";
import type { ApiCalculo } from "pages/calculo/types/ApiCalculo";
import { apiRelFichaProdutor } from "pages/relatorios/api/apiRelFichaProdutor";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, TableRelFinanceiroProdutor } from "./TableRelFinanceiroProdutor";

export function RelatorioFinanceiroProdutor() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelFichaProdutor", params],
		queryFn: () => apiRelFichaProdutor({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiCalculo> = useMemo(() => {
		return {
			type: "default",
			fileName: "relatorio-financeiro-produtor",
			options: {
				columns,
				data: registros,
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados Financeiro do Produtor";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Financeiro", "Produtor"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelFinanceiroProdutor data={data?.registros} title={title} />}
		/>
	);
}
